import { WebPlugin } from '@capacitor/core';
export class AudioPermissionsWeb extends WebPlugin {
    checkPermissions() {
        throw this.unimplemented('Not implemented on web.');
    }
    requestPermissions() {
        throw this.unimplemented('Not implemented on web.');
    }
}
//# sourceMappingURL=web.js.map